import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

/**
 * Axios instance for the whole app.
 * withCredentials=true lets the browser attach the httpOnly admin cookie
 * to every request automatically. No JWT is ever visible to JavaScript,
 * which mitigates the XSS token-exfiltration risk from localStorage.
 */
export const api = axios.create({
    baseURL: API_BASE,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
});

/**
 * Admin auth is now server-driven via an httpOnly cookie.
 * The frontend can no longer read/write the token, so authentication state
 * must be resolved by calling `AdminAuth.check()` which pings /admin/me.
 */
export const AdminAuth = {
    async check() {
        try {
            await api.get('/admin/me');
            return true;
        } catch (e) {
            return false;
        }
    },
    async login(password) {
        // On success the server sets a Set-Cookie header (httpOnly). The client
        // does not touch the token.
        await api.post('/admin/login', { password });
        return true;
    },
    async logout() {
        try {
            await api.post('/admin/logout');
        } catch (e) {
            // Network/server error on logout is non-fatal: we still clear the
            // client session. Log for debugging visibility.
            console.debug('Logout request failed (session cleared locally anyway):', e);
        }
        return true;
    },
};

export default api;
